import { useGetCompanyStatsQuery } from '@/store/api/companyApi';

export const useCompanyStats = (companyId: string) => {
  const {
    data: companyStats,
    isLoading: iscompanyStatsLoading,
    error,
    refetch: refetchCompanyStats,
  } = useGetCompanyStatsQuery(companyId, {
    skip: !companyId,
  });

  return {
    companyStats,
    error,
    iscompanyStatsLoading,
    refetchCompanyStats,
  };
};
